import { Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { ReactNode, useMemo } from "react";

export const OpenedAccountsTooltip = () => {
  const tooltipTitle: ReactNode = useMemo(() => {
    return (
      <ul className="pl-3 my-0">
        <li>
          Active - Next payment is in the future or up to 1 month overdue.
        </li>
        <li>Semi-Active - Next payment is 1-6 months overdue.</li>
        <li>Inactive - Next payment is more than 6 months overdue.</li>
      </ul>
    );
  }, []);

  const tooltipStyle: any = useMemo(
    () => ({
      maxWidth: "400px",
    }),
    [],
  );

  return (
    <Tooltip
      placement="top"
      title={tooltipTitle}
      overlayStyle={tooltipStyle}
      overlayClassName="text-sm"
    >
      <QuestionCircleOutlined className="text-md title logo-cursor" />
    </Tooltip>
  );
};
